module.exports = __webpack_public_path__ + "static_1764244025768/img/giftModule0.6a02fcb5.png";